import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { selectState } from '../../../store/slices/themeSlice'
import useCustomStyles from '../../../hooks/useCustomStyles'
import { headerTabsStyles } from '../../../assets/styles/ClientsStyles/headerTabsStyles'

interface Tab {
  value: string
  label: string
}

interface TabsProps {
  tabs: Tab[]
  selectedTab: string
  onSelect: (tabValue: string) => void
}

const HeaderTabs: FC<TabsProps> = ({ tabs, selectedTab, onSelect }) => {
  const { theme } = useSelector(selectState)
  const classes = useCustomStyles(headerTabsStyles, theme)
  return (
    <div className={classes.tabsContainer}>
      {tabs.map((tab) => (
        <div
          key={tab.value}
          onClick={() => onSelect(tab.value)}
          style={{
            minWidth: 78,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            padding: '10px 16px',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            background: selectedTab === tab.value ? '#fff' : 'none',
            transition: 'background 0.15s ease',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p
            style={{
              color: selectedTab === tab.value ? '#000' : '#3F3F3F',
              fontFamily:
                selectedTab === tab.value
                  ? 'Gilroy-SemiBold'
                  : 'Gilroy-Regular',
              fontSize: 16,
              textAlign: 'center',
              fontWeight: '400',
            }}
          >
            {tab.label}
          </p>
        </div>
      ))}
    </div>
  )
}

export default HeaderTabs
